import React, { useState } from "react";
import { Tabs, Tab } from "@mui/material";

const TabBar = ({ options, onClick }) => {
  const [tabValue, setTabValue] = useState(0);

  const handleSetTabValue = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div className="border !border-gray-100 rounded-[12px] w-full">
      <Tabs
        value={tabValue}
        onChange={handleSetTabValue}
        variant="scrollable"
        scrollButtons={true}
        allowScrollButtonsMobile
        sx={{
          "& .MuiTabs-scrollButtons.Mui-disabled": {
            width: 0,
            opacity: 0,
            display: "none",
          },
          "& .MuiTabs-scrollButtons": {
            transition: "width 0.3s, opacity 0.3s",
            width: "22px",
            backgroundColor: "#fff",
            borderRadius: "10px",
            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;",
            "& svg": {
              fontSize: "1.50rem",
            },
          },
        }}
      >
        {options.map((opt, i) => (
          <Tab onClick={() => onClick(opt)} key={i} label={opt.label} />
        ))}
      </Tabs>
    </div>
  );
};

export default TabBar;
